/**
 * `PublicAppLayout` — shell pubblica "app-like" usata dalle pagine pubbliche
 * che devono sembrare parte del software (es. la recap del CV pubblico), pur
 * restando FUORI dall'area autenticata.
 *
 * A differenza di `PublicLayout` (landing pulita, senza chrome), replica la
 * struttura visiva della `Layout` autenticata: stesso `app-shell`, header
 * `navbar` con il logo, corpo centrato in un container (`app-main`, max-width) e
 * `Footer` globale. NON mostra però navigazione di sezione, `UserMenu` né
 * dipende dall'autenticazione: il brand è un semplice link alla root del sito.
 */
import type { ReactNode } from 'react';
import { Footer } from './Footer';

export function PublicAppLayout({ children }: { children: ReactNode }) {
  return (
    <div className="app-shell">
      <header className="navbar">
        <div className="navbar__inner">
          {/* Brand: link alla root del sito (cursore a mano via `a.navbar__brand`). */}
          <a className="navbar__brand" href="/" aria-label="Vai alla home">
            <img className="navbar__logo" src="/imgs/logo.png" alt="Skills" />
          </a>
        </div>
      </header>
      <main className="app-main">{children}</main>
      <Footer />
    </div>
  );
}
